// Port of src/app/animations/pixelateInOutSearchBoxes.ts
// (Angular trigger 'pixelateInOutSearchBoxes').
//
// Angular spec: :enter from { opacity: 0, blur(5px) } -> { opacity: 1, blur(0) }
// over 1s ease-in; :leave -> { opacity: 0, blur(5px) } over 1ms ease-out
// (effectively instant).
//
// Ported as CSS keyframe classes (see react/src/styles/animations.scss).
// For leave, apply the leave class and unmount after
// PIXELATE_IN_OUT_SEARCH_BOXES_LEAVE_MS.

export const PIXELATE_IN_OUT_SEARCH_BOXES_ENTER_CLASS = 'pixelate-in-out-search-boxes-enter';
export const PIXELATE_IN_OUT_SEARCH_BOXES_LEAVE_CLASS = 'pixelate-in-out-search-boxes-leave';

export const PIXELATE_IN_OUT_SEARCH_BOXES_ENTER_MS = 1000;
export const PIXELATE_IN_OUT_SEARCH_BOXES_LEAVE_MS = 1;
